import axios from "axios";

export default {
  async create(formData) {
    return axios.post(`/customers`, formData);
  },
  async findOne({ id }) {
    return axios.get(`/customers/${id}`);
  },
  async findAll() {
    return axios.get('/customers');
  },
  async search(payload) {
    let url = `/customers/search?search=${payload.searchString}`
    return axios.get(url);
  },
  async findAllByStatus() {
    return axios.get(`/customers`);
  },
  async delete({ id }) {
    return axios.delete(`/customers/${id}`);
  },
  async update(formData) {
    return axios.put(`/customers/${formData.id}`, formData);
  }
};
